import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import HeadContainer from '../../../common/head-container';

const UsedLinkScreen = ({ setScreenNumber, telegramLink }) => {
  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url("${getImageFromS3('images/ua-hostess/bg.png')}")`
      }}
    >
      <HeadContainer
        setScreenNumber={setScreenNumber}
        customTelegramLink={telegramLink}
        telegramOnly
      />
      <div className={styles.content}>
        <p className={styles.title}>Посилання вже використане</p>
        <p className={styles.description}>
          Це посилання/QR-код вже використали для реєстрації, тож воно більше
          недійсне. Попроси нове посилання або QR-код у того, хто тебе запросив.
        </p>
      </div>
    </div>
  );
};

export default UsedLinkScreen;
